const YEAR_IN_MILLISECONDS = 365 * 24 * 60 * 60 * 1000;

class CookieManager {
  public static setCookie(
    name: string,
    value: string,
    expirationTimeInMillis?: number
  ) {
    if (!expirationTimeInMillis) {
      expirationTimeInMillis = 1000 * YEAR_IN_MILLISECONDS;
    }

    const d = new Date();
    d.setTime(d.getTime() + expirationTimeInMillis);
    const expires = `expires=${d.toUTCString()}`;
    const cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
      value
    )}; ${expires}`;
    document.cookie = cookieString;
  }

  public static deleteCookie(name: string) {
    document.cookie = `${encodeURIComponent(name)}=; max-age=0`;
  }

  public static getCookie(name: string): string | null | undefined {
    const match = document.cookie.match(
      new RegExp(
        `(?:(?:^|.*;)\\s*${encodeURIComponent(name)}\\s*\\=\\s*([^;]*).*$)|^.*$`
      )
    );
    return match ? match[1] : null;
  }
}

export { CookieManager };
